/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLoginReqVo
 */
export interface UserLoginReqVo {
    /**
     * 登录账号
     * @type {string}
     * @memberof UserLoginReqVo
     */
    account?: string;
    /**
     * 密码
     * @type {string}
     * @memberof UserLoginReqVo
     */
    password?: string;
}

/**
 * Check if a given object implements the UserLoginReqVo interface.
 */
export function instanceOfUserLoginReqVo(value: object): value is UserLoginReqVo {
    return true;
}

export function UserLoginReqVoFromJSON(json: any): UserLoginReqVo {
    return UserLoginReqVoFromJSONTyped(json, false);
}

export function UserLoginReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLoginReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'] == null ? undefined : json['account'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function UserLoginReqVoToJSON(json: any): UserLoginReqVo {
    return UserLoginReqVoToJSONTyped(json, false);
}

export function UserLoginReqVoToJSONTyped(value?: UserLoginReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'password': value['password'],
    };
}

